import { Navigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import LoginPage from './LoginPage';
import { logout } from '/src/store/slices/AuthSlice';
import ErrorBoundary from '../../components/ui/ErrorBoundary';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, token } = useSelector((state) => state.store.auth);
  const location = useLocation();
  const dispatch = useDispatch();
  
  // Check if the token is expired
  useEffect(() => {
    // Simple token validation - in a real app you might want to check JWT expiry
    const validateToken = async () => {
      if (token) {
        try {
          // Optionally, you could make a lightweight API call to validate the token
          // const response = await fetch('/api/validate-token', {
          //   headers: { Authorization: `Bearer ${token}` }
          // });
          // if (!response.ok) throw new Error('Invalid token');
        } catch (error) {
          console.error('Token validation failed:', error);
          // Token is invalid, log the user out
          dispatch(logout());
        }
      }
    };
    
    validateToken();
  }, [token, dispatch]);

  if (!isAuthenticated) {
    // Redirect to login with the current location for redirect after login
    return (
      <Navigate 
        to="/auth/login" 
        state={{ 
          from: location.pathname,
          message: location.state?.message || 'Please log in to access this page'
        }} 
        replace 
      />
    );
  }

  // Wrap the protected content in an ErrorBoundary to catch runtime errors
  return (
    <ErrorBoundary>
      {children}
    </ErrorBoundary>
  );
};
